import { combineReducers } from "redux";
import { questionnaireDetailsReducer } from "./questionnaireDetailsReducer";
import { testDetailsReducer } from "./testDetailsReducer";

export const rootReducer = () =>
  combineReducers({
    questionnaireDetails: questionnaireDetailsReducer,
    testDetails: testDetailsReducer,
  });
